export default {
  sales: [],
  contact: {},
  loading: false,
  form:{
    dates:[]
  }
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales-products/state.js